import { scrollToId } from "../App";
import { useNavigate, useLocation } from "react-router-dom";


const ButtonYellow = ({text, onclick=false, showLoader}) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="btn_yellow" onClick={() => {
            if (onclick) onclick();
            else {scrollToId(navigate, location, 'reserve_block')}
        }} style={{
            backgroundColor: "#D19200",
            color: "#181818",
            fontSize: 24,
            padding: "12px 30px",
            cursor: "pointer",
            textAlign: "center"
        }} disabled={showLoader}>
            {text}
        </div>
    )
}

export default ButtonYellow;